import AddIcon from "@mui/icons-material/Add";
import { default as CancelIcon, default as CloseIcon } from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Index.css";
import {
  Avatar,
  Badge,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
  GridToolbarContainer
} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import programDefaultImage from "../../assets/images/programlogo/p1.jpg";
import uploadFileImage from "../../assets/images/logos/image.png";
import { RecipeOptions } from "./ProgramResources";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

const userType = 2;
const appColor = "#59D6DF";
const initialRows = [];
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};
const RecipeDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: -6,
            right: 0,
            color: "black"
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ maxHeight: "70vh", overflowY: "auto", paddingTop: 4 }}>
          <Grid container spacing={2}>
            {details.map((program) => (
              <Grid item xs={12} key={program._id}>
                <Box
                  sx={{
                    position: "relative",
                    borderRadius: 4,
                    overflow: "hidden",
                    boxShadow: 2
                  }}
                >
                  <Box
                    onClick={() => {
                      navigate(`/recipes`, { state: program });
                    }}
                    sx={{
                      height: 180,
                      backgroundImage: `url(${program.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      padding: 2,
                      color: "white"
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                        color: "#FFFFFF"
                      }}
                    >
                      {program.name}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

function EditToolbar(props) {
  const {
    setRows,
    setRowModesModel,
    addedUser,
    setAddedUser,
    showToolbar,
    setShowToolbar,
    selectedProgram,
    setSelectedProgram
  } = props;
  const [open, setOpen] = React.useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [calories, setCalories] = useState("");
  const [email, setEmail] = useState("");
  const [totalDays, setTotalDays] = useState(0);
  const [selectedDays, setSelectedDays] = useState([]);
  const [fullNameError, setFullNameError] = useState("");
  const [recipeOptions, setRecipeOptions] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState([]);

  const [nameError, setNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [imageError, setImageError] = useState("");
  const [caloriesError, setCaloriesError] = useState("");
  const [totalDaysError, setTotalDaysError] = useState("");
  const [selectedRecipeError, setSelectedRecipeError] = useState("");
  const [selectedDaysError, setSelectedDaysError] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const handleDayClick = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setShowToolbar(false);
    setSelectedProgram({});
    setSelectedDays([]);
    setImageError("");
    setNameError("");
    setDescriptionError("");
    setCaloriesError("");
    setTotalDaysError("");
    setSelectedRecipeError("");
    setSelectedDaysError("");
  };

  const linkStart = selectedProgram?.image?.indexOf("h");
  function getPosition(string, subString, index) {
    if (typeof string !== "string") return;
    return string.split(subString, index).join(subString).length;
  }
  const linkEnd = getPosition(selectedProgram?.image, '"', 2);
  let link = "";
  if (linkStart && linkEnd) {
    for (let index = linkStart; index < linkEnd; index++) {
      link += selectedProgram?.image[index];
    }
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const acceptedTypes = ["png", "jpg", "jpeg"];
      const acceptedTypesLong = ["image/png", "image/jpg", "image/jpeg"];
      const nameExtension = file.name.split(".").pop();
      if (!acceptedTypes.includes(nameExtension) || !acceptedTypesLong.includes(file.type)) {
        setImageError("Please upload valid program image");
        return;
      } else {
        setImage(file);
        setImageError("");
      }
    }
  };

  useEffect(() => {
    if (Object.keys(selectedProgram).length) {
      setId(selectedProgram.id || "");
      setImage(selectedProgram.image ? link : "");
      setName(selectedProgram.name || "");
      setDescription(selectedProgram.description || "");
      setCalories(+selectedProgram.kcal || "");
      setTotalDays(+selectedProgram.days || "");
      const findSelectedRecipe = selectedProgram.recipes.map((value) => {
        return value?._id;
      });
      setSelectedRecipe(findSelectedRecipe);
      setSelectedDays(selectedProgram.restDays);
    } else {
      setId("");
      setImage("");
      setName("");
      setDescription("");
      setCalories("");
      setTotalDays("");
      setFullNameError("");
      setSelectedRecipe([]);
      setSelectedDays([]);
      setImageError("");
      setNameError("");
      setDescriptionError("");
      setCaloriesError("");
      setTotalDaysError("");
      setSelectedRecipeError("");
      setSelectedDaysError("");
    }
    RecipeOptions().then((value) => {
      setRecipeOptions(value);
    });
    setOpen(showToolbar);
  }, [showToolbar, selectedProgram]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof image == "string" && image.trim() == "") {
      setImageError("Program image is required");
    } else if (name == "") {
      setNameError("Program Name is required!");
    } else if (description == "") {
      setDescriptionError("Program Description is required!");
    } else if (!calories) {
      setCaloriesError("calories are required!");
    } else if (!totalDays) {
      setTotalDaysError("Total Days are required!");
    } else if (!selectedRecipe.length) {
      setSelectedRecipeError("Please select recipe for this program");
    } else if (!selectedDays.length) {
      setSelectedDaysError("Please select rest days for this program");
    } else if (selectedDays.includes(1)) {
      setSelectedDaysError("First day can't be a rest day!");
    } else {
      setIsSubmitting(true);
      const totalWeeks = totalDays % 7 == 0 ? totalDays / 7 : Math.ceil(totalDays / 7);
      console.log(
        image,
        name,
        description,
        calories,
        totalDays,
        totalWeeks,
        selectedRecipe,
        selectedDays,
        "add program  parameter"
      );
      const formData = new FormData();
      formData.append("id", id);
      formData.append("image", image);
      formData.append("name", name);
      formData.append("description", description);
      formData.append("kcal", calories);
      formData.append("days", totalDays);
      formData.append("week", totalWeeks);
      formData.append("selectedRecipe", selectedRecipe);
      formData.append("selectedDays", selectedDays);
      const headers = {
        "Content-Type": "multipart/form-data",
        "x-access-token": `${localStorage.getItem("token")}`
      };
      axios
        .post(`${apiBaseURL}/api/v1/admin/addupdateprograms`, formData, {
          headers: headers
        })
        .then((res) => {
          if (res.data) {
            setOpen(false);
            setShowToolbar(false);
            setAddedUser(!addedUser);
            setSelectedProgram({});
            const { message } = res.data;
            Swal.fire({
              position: "center",
              icon: "success",
              title: `${message}`,
              showConfirmButton: false,
              timer: 1000
            });
          }
        })
        .catch((error) => {
          setOpen(false);
          setShowToolbar(false);
          setAddedUser(!addedUser);
          setSelectedProgram({});
          const { message } = error.response.data;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: message
          });
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`
  }));

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Button
        sx={{ color: "#59D6DF", border: "1px solid grey" }}
        startIcon={<AddIcon />}
        onClick={handleOpen}
      >
        Add Programs
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Box mb={2}>
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    <SmallAvatar
                      alt="Remy Sharp"
                      src={uploadFileImage}
                      onClick={() => document.getElementById("picture").click()}
                    />
                  }
                >
                  <Avatar
                    sx={{
                      width: "80px",
                      height: "80px",
                      boxShadow: "0px 5px 10px 0px #163F7533",
                      p: !image && 3
                    }}
                    alt="Profile Picture"
                    src={image ? image : programDefaultImage}
                  />
                  <VisuallyHiddenInput
                    id="picture"
                    name="picture"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Badge>
                <InputLabel sx={{ pt: 1, color: "red" }}>{imageError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Program Name"
                  name="fullName"
                  value={name}
                  onChange={(event) => {
                    if (event) {
                      setName(event.target.value);
                      setNameError("");
                    }
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{nameError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Program Description"
                  name="description"
                  value={description}
                  multiline
                  rows={4}
                  variant="outlined"
                  onChange={(event) => {
                    if (event) {
                      setDescription(event.target.value);
                      setDescriptionError("");
                    }
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      backgroundColor: "white",
                      padding: "4px"
                    },
                    "& .MuiInputBase-input": {
                      p: "0px !important"
                    },
                    "& .MuiInputBase-root": {
                      pt: "15px !important",
                      px: 2
                    }
                  }}
                  InputLabelProps={{
                    shrink: description ? true : undefined
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{descriptionError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Calories(In KCAL)"
                  name="phoneNumber"
                  type="number"
                  value={calories}
                  onChange={(event) => {
                    if (event) {
                      setCalories(event.target.value);
                      if (!+event.target.value || +event.target.value < 0) {
                        setCaloriesError("Please enter valid calories!");
                      } else {
                        setCaloriesError("");
                      }
                    }
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{caloriesError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Total Days"
                  name="totalDays"
                  value={totalDays}
                  type="number"
                  onChange={(event) => {
                    if (event) {
                      setTotalDays(event.target.value);
                      if (!+event.target.value) {
                        setTotalDaysError("Total Days are required!");
                      } else {
                        setTotalDaysError("");
                      }
                    }
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{totalDaysError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-checkbox-label">
                    Select Recipe For Program
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    fullWidth
                    value={selectedRecipe}
                    input={<OutlinedInput label="Select Recipe For Program" />}
                    onChange={(event) => {
                      setSelectedRecipe(event.target.value);
                      if (selectedRecipe.length + 1) {
                        setSelectedRecipeError("");
                      }
                    }}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const option = recipeOptions.find((opt) => opt.id === value);
                          return option ? option.name : value;
                        })
                        .join(", ")
                    }
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                    MenuProps={MenuProps}
                  >
                    {recipeOptions.map((option) => (
                      <MenuItem key={option.name} value={option.id}>
                        <Checkbox checked={selectedRecipe.indexOf(option.id) > -1} />
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{selectedRecipeError}</InputLabel>
              </Box>
              <Box
                mb={2}
                sx={{
                  maxHeight: 200,
                  overflow: "auto"
                }}
              >
                <InputLabel sx={{ mt: 2 }} id="select-label">
                  Select Rest days(From Total days)
                </InputLabel>
                <FormControl fullWidth>
                  {totalDays ? (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        gap: 1,
                        p: 1
                      }}
                    >
                      {Array.from({ length: totalDays }, (_, i) => i + 1).map((day) => (
                        <Box
                          key={day}
                          sx={{
                            width: 30,
                            height: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            backgroundColor: selectedDays.includes(day) ? "#1976d2" : "white",
                            color: selectedDays.includes(day) ? "white" : "black",
                            fontSize: "16px"
                          }}
                          onClick={() => {
                            setSelectedDays((prev) =>
                              prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
                            );
                          }}
                        >
                          {day}
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Box></Box>
                  )}
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{selectedDaysError}</InputLabel>
              </Box>
              <Box mt={4} mb={1}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isSubmitting}
                  sx={{
                    backgroundColor: appColor,
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: appColor
                    }
                  }}
                  fullWidth
                >
                  {isSubmitting ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : Object.keys(selectedProgram).length ? (
                    "Update Program"
                  ) : (
                    "Register Program"
                  )}
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </GridToolbarContainer>
  );
}

const Programs = () => {
  const [rows, setRows] = React.useState(initialRows);
  const [addedUser, setAddedUser] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [calledPublishProgram, setCalledPublishProgram] = useState(false);
  const [profilePic, setProfilePic] = React.useState({});
  const [calledUpdateUser, setCallUpdateUser] = useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [debouncedSearchBy, setDebouncedSearchBy] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectRecipeDetails, setSelectRecipeDetails] = useState([]);
  const [showToolbar, setShowToolbar] = React.useState(false);
  const [selectedProgram, setSelectedProgram] = React.useState({});
  const { state } = useLocation();

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchBy(searchBy);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchBy]);

  // Reset pagination when search changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchBy]);

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleOpenModal = (details) => {
    setSelectRecipeDetails(details);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectRecipeDetails(null);
    setModalOpen(false);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };

        // Prepare request body with pagination and specific program ID if available
        const requestBody = {
          searchBy: debouncedSearchBy,
          page: paginationModel.page + 1, // API expects 1-based page numbers
          pageSize: paginationModel.pageSize
        };

        // Add specific program ID to request if available from state
        if (state?._id) {
          requestBody.specificProgramId = state._id;
        }

        const programList = await axios.post(
          `${apiBaseURL}/api/v1/admin/getprograms`,
          requestBody,
          {
            headers: headers
          }
        );
        if (programList.data) {
          const { allPrograms, total, currentPage, totalPages } = programList.data.data;
          const currentRows = allPrograms.map((value, index) => {
            return {
              id: value?._id,
              image: value?.image
                ? `<img src="${value?.image}" height="50" width="50"> `
                : `<img src="${apiBaseURL}/img/Profile.svg" height="50"> `,
              name: `${value?.name}`,
              description: `${value?.description}`,
              kcal: value?.kcal,
              days: value?.days,
              numberOfUsers: value?.numberOfUsers,
              recipes: value?.recipes?.length ? value?.recipes : null,
              restDays: value?.restDays ? value?.restDays : [],
              isPublished:
                value?.isPublished == true
                  ? `<button style="background-color:green; border: 1px solid transparent; height:40px; width:110px; font-size:20px; border-radius: 0.375rem; font-family:"Roboto","Helvetica","Arial",sans-serif; color:white; margin-top: 10px;">Published</button>`
                  : `<button style="background-color:#D22B2B;border: 1px solid transparent; height:40px; width:110px; font-size:18px; border-radius: 0.375rem;
                  font-family:"Roboto","Helvetica","Arial",sans-serif; color:white; margin-top: 10px;">Unpublished</button>`
            };
          });
          setRows(currentRows);
          setTotalRows(total || allPrograms.length);
        }
      } catch (error) {
        console.error("Error fetching programs:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch programs. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [
    addedUser,
    calledPublishProgram,
    calledUpdateUser,
    debouncedSearchBy,
    paginationModel.page,
    paginationModel.pageSize,
    state?._id
  ]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handlePublishButton = (id, published) => {
    if (published) return;
    if (id) {
      Swal.fire({
        title: `Are you sure you want to publish this program?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: appColor
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const headers = {
                "Content-Type": "application/json",
                "x-access-token": `${localStorage.getItem("token")}`
              };
              const publishprogram = await axios.post(
                `${apiBaseURL}/api/v1/admin/publishprogram`,
                {
                  id,
                  published
                },
                {
                  headers: headers
                }
              );
              if (publishprogram.data) {
                Swal.fire(
                  `The program is published now and can be seen at app side!`,
                  "",
                  "success"
                );
                setCalledPublishProgram(!calledPublishProgram);
              }
            } catch (error) {
              const { message } = error.response.data;
              Swal.fire({
                icon: "error",
                title: "Error",
                text: message
              });
            }
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        })
        .catch((error) => {
          console.log(error, "error in thencatch");
        });
    }
  };

  const handleDeleteClick = (id, numberOfUsers) => {
    // Check if program has users enrolled
    const hasUsers = numberOfUsers && numberOfUsers > 0;

    // Determine the message based on user count
    let titleMessage = "";
    if (hasUsers) {
      if (numberOfUsers === 1) {
        titleMessage = "Program Already Enrolled by User Are you sure you want to delete?";
      } else {
        titleMessage = "Program Already Enrolled by Users Are you sure you want to delete?";
      }
    } else {
      titleMessage = "Are you sure you want to delete this Program?";
    }

    Swal.fire({
      title: titleMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: appColor
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const headers = {
              "Content-Type": "application/json",
              "x-access-token": `${localStorage.getItem("token")}`
            };
            const deleteProgram = await axios.delete(`${apiBaseURL}/api/v1/admin/deleteprogram`, {
              headers: headers,
              data: {
                id
              }
            });
            if (deleteProgram.data) {
              Swal.fire("The program is deleted now!", "", "success");
              setRows(rows.filter((row) => row.id !== id));
            }
          } catch (error) {
            const { message } = error.response.data;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message
            });
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleFileChange = (e, params) => {
    const file = e.target.files[0];
    if (file) {
      const updatedRow = {
        ...params.row,
        // profilePic: `<img src="${URL.createObjectURL(file)}" />`,?
        profilePic: file
      };
      setProfilePic(updatedRow.profilePic);
      setRows((prevRows) => prevRows.map((row) => (row.id === params.id ? updatedRow : row)));
    }
  };

  const columns = [
    {
      field: "image",
      headerName: "Program Image",
      width: 150,
      sortable: false,
      type: "file",
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: params.value // Render the HTML content (image tag)
            }}
          />
        );
      },
      renderEditCell: (params) => {
        return (
          <Box>
            <VisuallyHiddenInput
              id="picture"
              name="picture"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, params)}
            />
            <IconButton
              aria-label="upload"
              sx={{
                border: "1px solid #F2F2F2",
                borderRadius: 2
              }}
              onClick={() => document.getElementById("picture").click()}
            >
              <img height="20" width="20" src={uploadFileImage} alt="upload icon" />
            </IconButton>
          </Box>
        );
      }
    },
    { field: "name", headerName: "Program Name", width: 250, sortable: false },
    { field: "description", headerName: "Program Description", width: 250, sortable: false },
    {
      field: "kcal",
      headerName: "Calories",
      type: "string",
      width: 150,
      sortable: false
    },
    {
      field: "days",
      headerName: "Total Days",
      width: 100,
      type: "number",
      sortable: false
    },
    {
      field: "recipes",
      headerName: "Recipe Details",
      width: 150,
      sortable: false,
      renderCell: (params) =>
        params.row.recipes ? (
          <IconButton sx={{ left: -30 }} onClick={() => handleOpenModal(params.row.recipes)}>
            <Button href="#text-buttons" style={{ textTransform: "none" }}>
              View Recipes
            </Button>
          </IconButton>
        ) : (
          "N/A"
        )
    },
    {
      field: "numberOfUsers",
      headerName: "Number of Users",
      width: 150,
      type: "string",
      sortable: false
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      sortable: false,
      getActions: (params) => {
        const id = params.row.id;
        // if (isInEditMode) {
        //   return [
        //     <GridActionsCellItem
        //       icon={<SaveIcon />}
        //       label="Save"
        //       sx={{
        //         color: "primary.main"
        //       }}
        //       onClick={() => {
        //         handleSaveClick(id);
        //       }}
        //     />,
        //     <GridActionsCellItem
        //       icon={<CancelIcon />}
        //       label="Cancel"
        //       className="textPrimary"
        //       onClick={() => {
        //         handleCancelClick(id);
        //       }}
        //       color="inherit"
        //     />
        //   ];
        // }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
              setShowToolbar(true);
              setSelectedProgram(params.row);
            }}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => {
              handleDeleteClick(id, params.row.numberOfUsers);
            }}
            color="inherit"
          />
        ];
      }
    },
    {
      field: "isPublished",
      headerName: "Publish/Unpublish",
      width: 200,
      type: "button",
      sortable: false,
      cellClassName: "actions",
      renderCell: (params) => {
        const { id, isPublished } = params.row;
        const published = isPublished.includes("Published");
        return (
          <div
            onClick={() => {
              handlePublishButton(id, published);
            }}
            dangerouslySetInnerHTML={{
              __html: params.value // Render the HTML content (image tag)
            }}
            style={{ width: "fit-content", marginTop: "5px" }}
          />
        );
      }
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <TextField
          id="outlined-basic"
          label="Search by Program Name"
          variant="outlined"
          value={searchBy}
          onChange={(event) => {
            setSearchBy(event.target.value);
          }}
          sx={{
            width: "300px"
          }}
        />
      </Box>
      <Box
        sx={{
          height: 675,
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          slots={{
            toolbar: EditToolbar
          }}
          // Server-side pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-row:focus": {
              outline: "none"
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none"
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
          slotProps={{
            toolbar: {
              setRows,
              setRowModesModel,
              addedUser,
              setAddedUser,
              showToolbar,
              setShowToolbar,
              selectedProgram,
              setSelectedProgram
            }
          }}
        />
        <RecipeDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          details={selectRecipeDetails}
        />
      </Box>
    </DashboardLayout>
  );
};

export default Programs;
